import { api } from "../lib/api";

export const updateBulk = (payload) =>
  api.post("/documents/access/bulk", payload).then((response) => response.data);
